module.exports = __webpack_public_path__ + "wall.be395b55b38c4e8b5ab5.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/assets/img/wall.jpg
// module id = ../../../../../src/assets/img/wall.jpg
// module chunks = styles